import { organisationRoutes, organisationNavigationItems } from "./router";
/**
 * Organisation Module
 */
export class OrganisationModule {
    constructor() {
        Object.defineProperty(this, "contracts", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
    }
    register(contracts) {
        this.contracts = contracts;
        contracts.logger.debug("[OrganisationModule] Registered");
        return {
            id: "organisation",
            name: "Organisation Module",
            version: "1.0.0",
        };
    }
    getRoutes() {
        return organisationRoutes;
    }
    getNavigationItems() {
        return organisationNavigationItems;
    }
    getComponent() {
        return null;
    }
    unregister() {
        this.contracts?.logger.debug("[OrganisationModule] Unregistered");
        this.contracts = null;
    }
}
export default new OrganisationModule();
